/**
 * CurrentGameRulesModal.tsx
 *
 * This is just a wrapper around the Current Game Rule
 */
import React from "react";

import { RulesHeader } from "../../Settings/Rules";
import { SingleGameRulesPage } from "../../Settings/RulesPages/SingleGameRulesPage";

import { ModalProps } from "../types/modalTypes";

export const CurrentGameRulesModal = (props: ModalProps): JSX.Element => {
  return (
    <>
      <RulesHeader {...props} />
      <div className="rulesModalContentContainer rules3">
        <SingleGameRulesPage {...props} />
      </div>
    </>
  );
};
